import React, { Component } from 'react';
import GridArea from './GridArea';


class ContentHolder extends Component {
    render() {
        return (
            <React.Fragment>
                <GridArea />
            </React.Fragment>      
        );
    }
}

export default ContentHolder;


// WEBPACK FOOTER //
// ./src/components/content/ContentHolder.js